import * as S from "./styled"

export const ForbiddenPage = () => (
  <S.Wrapper>
    <S.Title>Error 403</S.Title>
    <S.Text>You have don&apos;t permission to access this page</S.Text>
  </S.Wrapper>
)
